import { Chip, ChipProps as MuiChipProps, SxProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { getFormattedDuration } from "@app/analytics/utils";

import PauseIcon from "./PauseIcon";
import PlayIcon from "./PlayIcon";

export interface PlayClipProps {
  /** whether the clip is currently playing */
  playing?: boolean;
  duration: number;
  /** unit of time to show duration in; defaults to seconds (if over 60 seconds, will show minutes) */
  unit?: "seconds" | "minutes";
  size?: MuiChipProps["size"];
  sx?: SxProps;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

type ChipProps = MuiChipProps & { playing: boolean };

const StyledChip = styled(({ playing: _p, size: _s, ...props }: ChipProps) => (
  <Chip {...props} />
))(({ playing, size, theme }) => ({
  color: "#fff",
  borderRadius: "3px",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  fontSize: size == "small" ? "0.75rem" : "1.125rem",
  backgroundColor: playing
    ? theme.palette.shades.primary[500]
    : "rgba(0,0,0,0.5)",
  backdropFilter: "blur(0.5px)",
  height: size == "small" ? "20px" : "30px",
  "&:hover": {
    cursor: "pointer",
    backgroundColor: playing
      ? theme.palette.shades.primary[600]
      : "rgba(0,0,0,0.7)",
  },
  "&:active": {
    backgroundColor: theme.palette.shades.primary[500],
  },
  "& svg": {
    fontSize: size === "small" ? "10px" : "15px",
    marginRight: "6px !important",
  },
  "& .MuiChip-label": {
    paddingRight: "4px",
    paddingLeft: "0px",
    fontFamily: theme.typography.fontFamilySecondary,
  },
}));

const PlayClip = ({
  playing = false,
  duration,
  size = "small",
  sx,
  onClick,
  unit = "seconds",
}: PlayClipProps) => (
  <StyledChip
    icon={playing ? <PauseIcon /> : <PlayIcon />}
    label={getFormattedDuration(duration, { unit })}
    playing={playing}
    size={size}
    sx={sx}
    onClick={onClick}
  />
);

export default PlayClip;
